import React, { useRef, useMemo } from 'react';
import Button from 'react-bootstrap/Button';
import DismissableModal from 'components/DismissableModal';
import { MdDeleteForever } from 'react-icons/md';
import ToggleIconLinkButton from 'components/ToggleIconLinkButton';
import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import { getErrorMessage } from 'services/UtilityService';
import { showNotification } from 'services/NotificationService';

// dsoId, medName, dsgId, onSuccessDelete, codexId
const DynamicSwitchOptionDeleteModal = ({ dsoId, medName, dsgId, onSuccessDelete, codexId }) => {
  const modalRef = useRef(null);
  const modalRefId = useMemo(() => `DynamicSwitchOptionDeleteModal_${dsoId}`, [dsoId]);

  const onSuccess = () => {
    onSuccessDelete();

    // dispatch success notification
    showNotification({
      title: `Drug Deleted!`,
      message: `Drug Info deleted successfully`,
      position: "tr",
      type: "success"
    });
  }

  const onError = (r) => {
    // dispatch failure notification
    showNotification({
      title: "Something went wrong!",
      message:
        getErrorMessage(r.data) ||
        getErrorMessage("UNABLE_TO_DELETE_DYNAMIC_SWITCH_OPTION"),
      position: "tr",
      type: "error"
    });
  }

  const handleDeleteItem = () => {
    sendAuthenticatedAsyncRequest(
      `/cat/codex-version/${codexId}/dynamic-switch-groups/${dsgId}/dynamic-switch-options/${dsoId}`,
      "DELETE",
      null, onSuccess, onError);
    closeModal();
  }

  const openModal = () => {
    if (modalRef.current) {
      modalRef.current.handleShow();
    }
  }

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.handleClose();
    }
  }

  const modalOpener = <ToggleIconLinkButton
    key={`delete-${dsoId}`}
    shouldDisplayFirstTag={true}
    toggleButton={openModal}
    FirstIcon={MdDeleteForever}
    firstTag={"Delete"}
    linkClassName={'delete-link'}
    SecondIcon={null}
    secondTag={null}
  />;
  const customFooterContent = <div>
    <Button key={`dynamic-switch-option-delete-modal-cancel-${dsoId}`} id='dynamic-switch-option-delete-modal-cancel-button' variant="outline-dark" onClick={closeModal}>Cancel</Button>
    <Button
      key={`dynamic-switch-option-delete-modal-${dsoId}`}
      id='dynamic-switch-option-modal-delete-button'
      className="left-spacer"
      variant="danger"
      onClick={handleDeleteItem}>
      Delete
    </Button>
  </div>;
  const title = "Delete Drug Option?";
  return (
    <DismissableModal
      ref={modalRef}
      key={dsoId}
      customFooterContent={customFooterContent}
      openModalButton={modalOpener}
      title={title}
      id='dynamic-switch-option-delete-modal-dismissable-modal'
    >
      <p >
        Are you sure you want to delete the drug option <strong >{medName}</strong>?
      </p>

    </DismissableModal>
  );
}

export default DynamicSwitchOptionDeleteModal;